// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"152":"85456549","996":"9a634a30"}[chunkId] + ".js";
};